export default [
  { text: "About", url: "#about" },
  { text: "Work", url: "#work" },
  { text: "Employment", url: "#employment" },
  { text: "Contact", url: "#contact" },
];
